<template>
  <svg
    :class="svgClass"
    v-on="$listeners"
    :height="iconHeight"
    :width="iconWidth"
  >
    <use :xlink:href="iconName" />
    <slot />
  </svg>
</template>

<script>
export default {
  name: "SvgIcon",
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ""
    },
    height: {
      type: Number,
      default: null
    },
    width: {
      type: Number,
      default: null
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`;
    },
    iconHeight() {
      if (this.height) {
        return this.height + "px";
      } else {
        return null;
      }
    },
    iconWidth() {
      if (this.width) {
        return this.width + "px";
      } else {
        return null;
      }
    },
    svgClass() {
      if (this.className) {
        return "svg-icon " + this.className;
      } else {
        return "svg-icon";
      }
    },
    styleExternalIcon() {
      return {
        mask: `url(${this.iconClass}) no-repeat 50% 50%`,
        "-webkit-mask": `url(${this.iconClass}) no-repeat 50% 50%`
      };
    }
  }
};
</script>
<style scoped>
.svg-icon {
  width: 15.73px;
  height: 13px;
  vertical-align: -0.25em;
  fill: currentColor;
  overflow: hidden;
}
.svg-external-icon {
  background-color: currentColor;
  mask-size: cover !important;
  display: inline-block;
}
</style>
